import '../../css_styles/button_styles.css'
import CyclePrev from './CyclePrev'
import CycleNext from './CycleNext'


import { useState, useEffect } from 'react';

function OptimizationCycleNavigation(props) {

    const [prevActive, setPrevActive] = useState(false);
    const [nextActive, setNextActive] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showCreate, setShowCreate] = useState(false);

    useEffect(() => {
        if (props.cycleId > 0) {setPrevActive(true);}
        else {setPrevActive(false);}
        if (props.cycleId < props.numCycles-1) {setNextActive(true);}
        else {setNextActive(false);}

        if (props.cycleId === props.numCycles-1){setShowDelete(true);}
        else {setShowDelete(false);}

        if (props.numCycles === 0){setShowCreate(true);}
        else if (!props.cycleActive && props.cycleId === props.numCycles-1){setShowCreate(true);}
        else {setShowCreate(false);}

    }, [props.cycleId, props.numCycles, props.cycleActive]);




    let numCycles = props.numCycles
    let cycleId = props.cycleId+1;

    let cycleNav = (<></>);
    let actionPanel = (<></>);
    let deleteButton = (<></>);
    let createButton = (<></>);

    if(props.numCycles > 0) {
        cycleNav = (<>
                <CyclePrev handleClick={props.handleCyclePrev} active={prevActive}/>   
                    <div style={{margin:'0px', marginRight:'9px'}}>Cycle {cycleId} of {numCycles}</div>
                <CycleNext handleClick={props.handleCycleNext} active={nextActive}/>
        </>);
        if(showDelete) { 
            deleteButton = (<>
                                <button className={'actionButton'} style={{width:'150px', margin:'0px'}} onClick={props.handleDeleteCycle} >Delete Cycle</button> 
                            </>);
        }
        if(showCreate) { 
            createButton = (<>
                               <button className={'actionButton'} style={{width:'150px', marginRight:'0px', marginLeft:'10px'}} onClick={props.handleCreateCycle} >Start Next Cycle</button> 
                            </>);
        }
        actionPanel = (<>
                <div style={{ marginLeft: 'auto', display:'flex' }}>
                    {deleteButton}
                    {createButton}
                </div>
        </>);
    }
    else {
        actionPanel = (<>
            <div style={{ marginLeft: 'auto', display:'flex' }}>
                <button className={'actionButton'} style={{width:'150px', margin:'0px'}} onClick={props.handleCreateCycle} >Start Initial Cycle</button>
            </div>
        </>);
    }


    return (<>
            <div style = {{'marginTop': '20px', 'marginBottom': '0px', 'border':'none', 'outline':'none', 'padding':'0px', display:'flex', alignItems:'center',
                     'fontSize': '24px', 'fontWeight':'bold', position: 'relative', left:'3%', width:'94%'}} >
                {cycleNav}
                {actionPanel}
            </div>
    </>);
}

export default OptimizationCycleNavigation